import { render } from "./SaasHeader.vue?vue&type=template&id=26682145"
import script from "./SaasHeader.vue?vue&type=script&lang=js"
export * from "./SaasHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__